<template><div class="CruiseHeadOverview">

    <div class="boat__navigation boat-navigation">
        <OPartLink name="Route" :active="sectionActive">Маршрут <span>и экскурсии</span></OPartLink>
        <OPartLink name="Overview" :active="sectionActive">Описание</OPartLink>
        <OPartLink name="Ship" :active="sectionActive">Теплоход</OPartLink>
        <OPartLink name="Promotions" :active="sectionActive">Акции <span>и скидки</span></OPartLink>
        <OPartLink name="Cabins" :active="sectionActive">Каюты</OPartLink>
    </div>

    <div class="boat__serv">

        <OPart name="Route">
            <div class="boat__route">
                <div class="boat__route-title">Маршрут</div>
                <div class="boat__route-cities">{{routeFull}}</div> 
            </div>

            <TimetableInf v-if="timetable_inf.length" :timetable="timetable_inf" />
        </OPart>

        <OPart name="Overview">
            <div class="description">
                <div class="description__header" id="anchor1">Описание</div>
                <div class="description__content">

                    <InsertHtml v-if="description.has"  class="description__text" v-bind="description" />

                    <IncludedBlock 
                        v-if="included.has" 
                        :included="included" 
                        icon="included"
                        iconClass="vicon-bluefigma"
                        title="В стоимость тура входит" 
                    />


                    <IncludedBlock 
                        v-if="excluded.has" 
                        :included="excluded" 
                        icon="excluded"
                        iconClass="vicon-orange"
                        title="Дополнительные услуги, не включенные в стоимость" 
                    />


                    <IncludedBlock 
                        v-if="restaurants.has" 
                        :included="restaurants" 
                        icon="restaurants"
                        iconClass="vicon-bluefigma"
                        title="Рестораны" 
                    />

                </div>
            </div>
        </OPart>

        <OPart name="Ship">
            <ShipShort :ship="props.CruiseBook.ship" />
        </OPart>

        <OPart name="Promotions">
            <div class="promotions">
                <div class="promotions__header">Акции и скидки</div>
                <div class="promotions__content">
                    <div class="promotions__text">
                        Состав и точное количество скидок уточняйте у менеджера при бронировании криуза. Для получения скидки необходимо предъявить подтверждающие документы.
                    </div>

                    <Discount
                        :discountob="discountob" 
                        :show="true"
                        title="Акции и скидки" 
                    />
                </div>
            </div>
        </OPart>

        <OPart name="Cabins">
            <div class="cabins">
                <div class="cabins__header">Выбор свободных кают</div>
                <div class="cabins__content">
                    <div class="cabins__text">
                        Каюты сгруппированы по расположению и стоимости. Одновременно можно забронировать до 3х кают.
                    </div>

                    <SelectCabins />
                </div>
            </div>
        </OPart>


    </div>


</div></template>

<style lang="scss">
    .debug-mesto {
        background: #ffaaaa;
        display: flex;
        height: 500px;
        width: 100%;
        justify-content: stretch;
        align-items: top;
        font-size: 22px;
        border:  #aaa 5px dotted;
    }
</style>

<script setup>
import {onMounted, onBeforeUnmount, ref, unref, nextTick} from 'vue'
import useCruise from "@/comp/useCruise.js"
import OPart from "./Overview/OPart.vue"
import OPartLink from "./Overview/OPartLink.vue"
import TimetableInf from './TimetableInf.vue'
import {observeVertical} from '@/comp/observeVertical.js'

import IncludedBlock from '@/comp/IncludedBlock/IncludedBlock.vue'
import ShipShort from "@/comp/Ship/ShipShort.vue"
import Discount from "@/comp/CruiseHead/Discount.vue"
import SelectCabins from "@/comp/FaseList/SelectCabins.vue"

import InsertHtml from '@/comp/IncludedBlock/InsertHtml.vue'

import { NAV_DICT, anchor  } from  './Overview/NAV.js'

const props = defineProps({
    CruiseBook: Object, // то что вернул запрос 
})
const emits = defineEmits([ 'hideInfoGrid' ])

const sectionActive = ref('')

const { 
    routeFull, cruise_link_anchor, timetable_inf, description, included, excluded, restaurants, discountob,
} = useCruise(props.CruiseBook) // {cruiseHead, cruiseFull}


let observer = null

const isActive =  name => {
    return name === sectionActive.value
}

const setActiveSection = (name) => {
    sectionActive.value = name
//    console.log("setActiveSection", name)
//    let hide = ['Cabins','Promotions'].includes( name )
    emits('hideInfoGrid', name)
}

const addToObserve = () => {
    Object.keys(NAV_DICT).forEach( name => {
        const id = anchor(name)
        let el = document.getElementById(id)
        if (el) {
            observer.observe( el )
        }
//console.log('observer.observe', name, el)
    })
}

onMounted(() => {
    const rootMargin =  "-100px 0px 0px 0px"
//    showRootMarginOverlay(rootMargin)
    if (observer) {// на всякий пожарный убить старое
        observer.disconnect()
    }
    observer = observeVertical( { 
        nameAttr: 'data-name',
        setActiveSection,
        rootMargin, // boat__navigation height + 1
    } )

    nextTick( addToObserve )
} )

onBeforeUnmount(() => {
    if (observer) {
        observer.disconnect()
        observer = null
    }
})

function showRootMarginOverlay(rootMargin) {// отладка debug
  let [top, right, bottom, left] = rootMargin.split(/\s+/);

  const el = document.createElement('div');
  el.id = 'io-root-margin-debug';

  top = top.replace(/^-/,'')
  bottom = bottom.replace(/^-/,'')

//console.log('showRootMarginOverlay', top, right, bottom, left)
//console.log('showRootMarginOverlay', top, right, bottom, left)

  Object.assign(el.style, {
    position: 'fixed',
    top,
    left,
    right,
    bottom,
    background: 'rgba(255, 128, 0, 0.3)',
//    outline: '1px solid rgba(0, 128, 255, 0.7)',
    pointerEvents: 'none',
    zIndex: '9999',
  });

  document.body.appendChild(el);
}

    // watch на route anchor и scroll
    // тут же IntersectionObserver
</script>
